import { render } from "./AccommodationPricesWidget.vue?vue&type=template&id=d0da8d64"
import script from "./AccommodationPricesWidget.vue?vue&type=script&lang=js"
export * from "./AccommodationPricesWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/approot/build.20261030-093834-708061d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__